import axios from 'axios'

const API = axios.create({
  baseURL: '/_/'
})

export default API